// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import VueHotkey from "v-hotkey"
import Feedback from './components/shared/feedback'
import installAutoReload from '@/plugins/auto-reload-utility'

import './plugins/chartjs'

Vue.use(VueHotkey);
Vue.use(Feedback);

Vue.config.productionTip = false

Vue.component('CustomIcon', require('./components/shared/customIcon').default)

installAutoReload(router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js